// 引导页
const routes = [
    {
        path: "/guide",
        name: "guide_index",
        component: () => import("../views/guide/index.vue"),
        meta: { h5Header: true, h5TitleKey: "guide.title" },
        children: [
            {
                name: "guide_accessory",
                path: "accessory",
                component: () => import("../views/guide/accessory.vue"),
                meta: { h5TitleKey: "user.apply.accessory.title" },
            },
            {
                name: "guide_backup",
                path: "backup",
                component: () => import("../views/guide/backup.vue"),
                meta: { h5TitleKey: "user.apply.backup.title" },
            },
            {
                name: "guide_repair",
                path: "repair",
                component: () => import("../views/guide/repair.vue"),
                meta: { h5TitleKey: "apply.repairTitle" },
            },
        ],
    },
];

export default routes;
